import { ref } from 'vue';
import useFlashMessage from './useFlashMessage';
import { getCurrentAdmin, logoutAdmin } from '../api/admin/AuthApi';
import { useRouter } from 'vue-router';

// ログインユーザー
const currentAdmin = ref();

export function useAuthAdmin() {
  const router = useRouter();

  /**
   * ログアウト処理
   *
   * @returns {Promise<void>}
   */
  async function logout() {
    const { showFlashMessage } = useFlashMessage();

    try {
      await logoutAdmin();
    } catch (err) {
      return;
    }

    currentAdmin.value = null;
    showFlashMessage('success', 'ログアウトしました');

    await router.push({ name: 'admin.login' });
  }

  /**
   * ログイン中のユーザーを取得
   *
   * @returns {Promise<any>}
   */
  async function fetchCurrentAdmin() {
    currentAdmin.value = await getCurrentAdmin();
  }

  return {
    logout,
    currentAdmin,
    fetchCurrentAdmin,
  };
}
